import { useEffect, useState } from 'react';
import { fetch } from '@zapier/auth-pages/src/utils';
import { urls } from '@zapier/identity-utils';

type ZapTemplateResult = {
  head_service: {
    id: string;
    image: string;
    name: string;
  };
  id: string | number;
  tail_service: {
    id: string;
    image: string;
    name: string;
  };
  title: string;
};

export type ZapTemplate = {
  headService: {
    id: string;
    image: string;
    name: string;
  };
  id: string | number;
  tailService: {
    id: string;
    image: string;
    name: string;
  } | null;
  title: string;
};

export function useZapTemplate(id: string | number | null) {
  const [isLoading, setIsLoading] = useState(true);
  const [zapTemplate, setZapTemplate] = useState<ZapTemplate | null>(null);

  useEffect(() => {
    async function getZapTemplate() {
      const results = await fetch<ZapTemplateResult>(
        `${urls.ZAP_TEMPLATE_API_URL}/${id}/`
      );

      setIsLoading(false);

      const rawTemplate = results.body;

      setZapTemplate({
        headService: {
          id: rawTemplate.head_service?.id,
          image: rawTemplate.head_service?.image,
          name: rawTemplate.head_service?.name,
        },
        id: rawTemplate.id,
        tailService: {
          id: rawTemplate.tail_service?.id,
          image: rawTemplate.tail_service?.image,
          name: rawTemplate.tail_service?.name,
        },
        title: rawTemplate.title,
      });
    }

    if (!id) {
      setZapTemplate(null);
    } else {
      getZapTemplate();
    }
  }, [id, setIsLoading, setZapTemplate]);

  return {
    isLoading,
    zapTemplate,
  };
}
